import { render, staticRenderFns } from "./ContactsTab.vue?vue&type=template&id=78e6cc64&scoped=true&"
import script from "./ContactsTab.vue?vue&type=script&lang=js&"
export * from "./ContactsTab.vue?vue&type=script&lang=js&"
import style0 from "./ContactsTab.vue?vue&type=style&index=0&id=78e6cc64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6cc64",
  null
  
)

export default component.exports